<template>
  <div class="law-firm-app">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="header-content">
        <div class="logo">
          <h1>律师事务所</h1>
        </div>
        <nav class="nav">
          <ul>
            <li><a href="#">首页</a></li>
            <li><a href="#">关于我们</a></li>
            <li><a href="#">律师团队</a></li>
            <li><a href="#">服务领域</a></li>
            <li><a href="#">联系我们</a></li>
          </ul>
        </nav>
      </div>
    </header>

    <!-- 律师团队展示 -->
    <section class="team-section">
      <div class="container">
        <h2>专业律师团队</h2>
        <div class="team-list">
          <div class="lawyer-card" v-for="lawyer in lawyers" :key="lawyer.id">
            <div class="lawyer-image">
              <img :src="lawyer.image" :alt="lawyer.name" />
            </div>
            <div class="lawyer-info">
              <h3>{{ lawyer.name }}</h3>
              <p class="position">{{ lawyer.position }}</p>
              <p class="expertise">{{ lawyer.expertise }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务领域介绍 -->
    <section class="services-section">
      <div class="container">
        <h2>主要服务领域</h2>
        <div class="services-list">
          <div class="service-card" v-for="service in services" :key="service.id">
            <div class="service-icon">{{ service.icon }}</div>
            <h3>{{ service.title }}</h3>
            <p>{{ service.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact-section">
      <div class="container">
        <h2>联系我们</h2>
        <div class="contact-content">
          <div class="contact-info">
            <div class="contact-item">
              <span class="contact-icon">📍</span>
              <p>北京市朝阳区建国路88号</p>
            </div>
            <div class="contact-item">
              <span class="contact-icon">📞</span>
              <p>010-88888888</p>
            </div>
            <div class="contact-item">
              <span class="contact-icon">📧</span>
              <p>info@lawfirm.com</p>
            </div>
          </div>
          <div class="contact-form">
            <form>
              <div class="form-group">
                <input type="text" placeholder="您的姓名" required>
              </div>
              <div class="form-group">
                <input type="email" placeholder="您的邮箱" required>
              </div>
              <div class="form-group">
                <textarea placeholder="您的咨询内容" rows="4" required></textarea>
              </div>
              <button type="submit" class="submit-btn">提交咨询</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      lawyers: [
        {
          id: 1,
          name: '张三',
          position: '主任律师',
          expertise: '刑事辩护、知识产权',
          image: '?prompt=professional%20male%20lawyer%20in%20suit%2C%20confident%2C%20courtroom%20background&image_size=square'
        },
        {
          id: 2,
          name: '李四',
          position: '合伙人律师',
          expertise: '婚姻家庭、遗产继承',
          image: '?prompt=professional%20female%20lawyer%20in%20suit%2C%20professional%2C%20office%20background&image_size=square'
        },
        {
          id: 3,
          name: '王五',
          position: '资深律师',
          expertise: '房地产、合同纠纷',
          image: '?prompt=professional%20male%20lawyer%20in%20suit%2C%20experienced%2C%20business%20background&image_size=square'
        }
      ],
      services: [
        {
          id: 1,
          icon: '⚖️',
          title: '刑事辩护',
          description: '专业的刑事辩护服务，保护客户合法权益'
        },
        {
          id: 2,
          icon: '💼',
          title: '企业法务',
          description: '为企业提供全方位的法务咨询和服务'
        },
        {
          id: 3,
          icon: '🏠',
          title: '房地产',
          description: '房地产交易、纠纷解决等专业服务'
        },
        {
          id: 4,
          icon: '👨‍👩‍👧‍👦',
          title: '婚姻家庭',
          description: '婚姻、继承、子女抚养等家庭法律事务'
        },
        {
          id: 5,
          icon: '💡',
          title: '知识产权',
          description: '专利、商标、版权等知识产权保护服务'
        },
        {
          id: 6,
          icon: '🏥',
          title: '医疗纠纷',
          description: '医疗事故、医患纠纷等专业法律服务'
        }
      ]
    }
  }
}
</script>

<style scoped>
/* 全局样式 */
.law-firm-app {
  font-family: Arial, sans-serif;
  color: #333;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 顶部导航栏 */
.header {
  background-color: #1a1a2e;
  color: white;
  padding: 1rem 0;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.logo h1 {
  font-size: 1.8rem;
  margin: 0;
}

.nav ul {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.nav ul li {
  margin-left: 2rem;
}

.nav ul li a {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease;
}

.nav ul li a:hover {
  color: #42b983;
}

/* 律师团队展示 */
.team-section {
  padding: 4rem 0;
  background-color: #f5f5f5;
}

.team-section h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  color: #1a1a2e;
}

.team-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.lawyer-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: calc(33.333% - 1.5rem);
  margin-bottom: 2rem;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.lawyer-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.lawyer-image img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}

.lawyer-info {
  padding: 1.5rem;
}

.lawyer-info h3 {
  font-size: 1.5rem;
  margin: 0 0 0.5rem 0;
  color: #1a1a2e;
}

.lawyer-info .position {
  color: #666;
  font-size: 1.1rem;
  margin: 0 0 0.5rem 0;
}

.lawyer-info .expertise {
  color: #888;
  font-size: 0.9rem;
  margin: 0;
}

/* 服务领域介绍 */
.services-section {
  padding: 4rem 0;
  background-color: white;
}

.services-section h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  color: #1a1a2e;
}

.services-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.service-card {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #e0e0e0;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.service-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.service-card h3 {
  font-size: 1.5rem;
  margin: 0 0 1rem 0;
  color: #1a1a2e;
}

.service-card p {
  color: #666;
  font-size: 1rem;
  margin: 0;
}

/* 联系我们 */
.contact-section {
  padding: 4rem 0;
  background-color: #1a1a2e;
  color: white;
}

.contact-section h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.contact-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.contact-info {
  width: calc(50% - 2rem);
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.contact-icon {
  font-size: 1.5rem;
  margin-right: 1rem;
  color: #42b983;
}

.contact-form {
  width: calc(50% - 2rem);
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 1rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
}

.submit-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-btn:hover {
  background-color: #369c70;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
  }

  .nav ul {
    margin-top: 1rem;
  }

  .nav ul li {
    margin: 0 1rem;
  }

  .lawyer-card {
    width: 100%;
  }

  .contact-info,
  .contact-form {
    width: 100%;
  }

  .contact-form {
    margin-top: 2rem;
  }
}
</style>
